import React from "react";
import loader from "../assets/loader.webp";

function Pagination({
  currentPage,
  totalPage,
  onPageChange,
  setIsNextLoading,
  setIsPrevLoading,
  isPrevLoading,
  isNextLoading,
}) {
  // console.log(currentPage, totalPage);
  const handlePrev = () => {
    if (currentPage > 1) {
      setIsPrevLoading(true);
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPage) {
      setIsNextLoading(true);
      onPageChange(currentPage + 1);
    }
  };
  return (
    <div className="flex justify-between w-full items-center pt-4 gap-4">
      <button
        onClick={handlePrev}
        className=" p-3 bg-darkblue text-white rounded-lg"
      >
        {isPrevLoading ? (
          <img src={loader} alt="lodr" className="w-4" />
        ) : (
          "Prev"
        )}
      </button>
      <h3> {`Page ${currentPage} of ${totalPage}`}</h3>
      <button
        onClick={handleNext}
        className=" p-3 bg-darkblue text-white rounded-lg"
      >
        {isNextLoading ? (
          <img src={loader} alt="lodr" className="w-4" />
        ) : (
          "Next"
        )}
      </button>
    </div>
  );
}

export default Pagination;
